export const getStaffPositions = (positions, language) =>
  positions
    .map((position) =>
      language === "ru"
        ? position.name || position.nameEn
        : position.nameEn || position.name
    )
    .join(", ");
